import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SOLENOID_VERIFICATION_RESULT_RANGE, SolenoidVerificationResult } from "../solenoidVerification.js";
import { SensorElementConfig } from "./types.js";
import { makeSimpleDigitalSensorElement } from "./simpleDigitalSensorElements.js";

/**
 * The result of a solenoid actuation check — a {@link SolenoidVerificationResult} enum member, not a
 * quantity.
 *
 * Renamed from `gen4SolenoidVerification` — the values and the concept are not Gen-4-specific even
 * though only the Gen 4 output cluster carries one today. Sprout has no solenoid verification at all,
 * and Sapling has its own separate element below.
 *
 * A categorical sensor element with its own unit category, mirroring `outputOperatingMode` rather than
 * `makeSimpleDigitalSensorElement`, so an out-of-range value is caught instead of silently accepted.
 */
export const solenoidVerificationElementConfig: SensorElementConfig<
    Record<string, never>,
    typeof SensorConversions.unity
> = {
    legalConvertedRange: SOLENOID_VERIFICATION_RESULT_RANGE,
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}) as Record<string, never>,
    decodedUnits: "dimensionless",
    convertedUnits: "dimensionless",
    unitCategory: "solenoidVerification",
    testCases: [
        {
            parameters: {},
            decodedValue: SolenoidVerificationResult.SUCCESS,
            convertedValue: SolenoidVerificationResult.SUCCESS,
        },
        {
            parameters: {},
            decodedValue: SolenoidVerificationResult.FAIL_OPEN_CIRCUIT,
            convertedValue: SolenoidVerificationResult.FAIL_OPEN_CIRCUIT,
        },
        {
            parameters: {},
            decodedValue: SolenoidVerificationResult.FAIL_PIN_STUCK,
            convertedValue: SolenoidVerificationResult.FAIL_PIN_STUCK,
        },
    ],
};

export const saplingVerificationElementConfig = makeSimpleDigitalSensorElement("code", 1);
